const $ = jQuery.noConflict()

var self = module.exports = {
  init: function (trigger) {
    $(trigger).each(function () {
      var endTime = $(this).data('countdown-timer-date')
      var ended = $(this).closest('.countdown-timer').find('[data-countdown-timer-ended]')
      // var endTime = '02 Jan 1970 00:00:00 GMT'

      if (endTime) {
        self.event.interval(this, endTime, ended)
      }
    })
  },

  event: {
    interval: function (countdownTimer, endTime, ended) {
      self.service.makeTimer(countdownTimer, endTime, ended)
      
      setInterval(function () {
        self.service.makeTimer(countdownTimer, endTime, ended)
      }, 1000)
    },
  },

  service: {
    makeTimer: function (countdownTimer, endTime, ended) {
      endTime = (Date.parse(endTime) / 1000)

      var now = new Date()
      now = (Date.parse(now) / 1000)

      var timeLeft = endTime - now

      if (timeLeft <= 0) {
        var days = 0
        var hours = 0
        var minutes = 0
        var seconds = 0

        if (ended) {
          ended.text(ended.data('countdown-timer-ended'))
        }
      } else {
        var days = Math.floor(timeLeft / 86400)
        var hours = Math.floor((timeLeft - (days * 86400)) / 3600)
        var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600)) / 60)
        var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)))
      }

      if (hours < "10") {
        hours = "0" + hours
      }

      if (minutes < "10") {
        minutes = "0" + minutes
      }

      if (seconds < "10") {
        seconds = "0" + seconds
      }

      $(countdownTimer).children('.days').html(days + "<span>Days</span>")
      $(countdownTimer).children('.hours').html(hours + "<span>Hours</span>")
      $(countdownTimer).children('.minutes').html(minutes + "<span>Minutes</span>")
      $(countdownTimer).children('.seconds').html(seconds + "<span>Seconds</span>")
    }
  }
}
